import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/insitestore360';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuAccessService {
  private readonly baseUrl = `${environment.apiUrl}/project-management-service/menu-access`;

  constructor(private http: HttpClient) { }

  getMenuAccess(roleId?: number, userId?: number, countryId?: number): Observable<any[]> {
    let params = new HttpParams();
    if (roleId) params = params.set('roleId', roleId.toString());
    if (userId) params = params.set('userId', userId.toString());
    if (countryId) params = params.set('countryId', countryId.toString());
    
    return this.http.get<any>(`${this.baseUrl}/getMenuAccess`, { params }).pipe(
      map(res => res.result || res || [])
    );
  }

  getUsersByRoleAndCountry(roleId: number, countryId: number): Observable<any[]> {
    let params = new HttpParams();
    params = params.set('roleId', roleId.toString());
    params = params.set('countryId', countryId.toString());
    
    return this.http.get<any>(`${this.baseUrl}/getUsersByRoleAndCountry`, { params }).pipe(
      map(res => res.result || res || [])
    );
  }

  updateMenuAccess(data: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/update`, data);
  }
}
